import { getTotalPlayedTimeInSeconds } from "../../../shared/analytics/media";
export const playerGetPlayedTimeForAnalytics = (isPlayheadAvailable, playerMgr) => {
  return isPlayheadAvailable ? () => playerMgr.current?.getCurrentTime() : getTotalPlayedTimeInSeconds;
};
